import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
  name: 'dateformat'
})
@Injectable({
  providedIn: 'root'
})
export class DateFormatPipe implements PipeTransform {

  transform(dateString: string): string {
    const date = new Date(dateString);
    return date.getDate().toString().padStart(2, '0') + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear();
  }

}
